import {gql, useQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";
import {useMemo} from "react";

const QUERY = gql`
query GetCompanyShareDetails {
  companyShareCollection {
    items {
      title
      priceChf
      priceEur
      priceGbp
      annualCharge
    }
  }
}`;

const useCompanyShareDetails = () => {
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    if (error) {
        // Error handling
        logger(error?.message, "error", "useCompanyShareDetails", error?.stack);
    }

    const item = data?.companyShareCollection?.items[0] || null;

    const companyShare = {
        title: item?.title,
        price: {
            CHF: item?.priceChf ?? null,
            EUR: item?.priceEur ?? null,
            GBP: item?.priceGbp ?? null
        },
        annualCharge: item?.annualCharge ?? null,
    };

    const memoVal = useMemo(() => {
        return { 
            companyShare, 
            loading 
        };
    }, [companyShare, loading]);

    return memoVal;
};

export default useCompanyShareDetails;